import { createStyles, makeStyles, Theme } from 'ui-components';
import { fontText } from 'common-react';

export default makeStyles<Theme, { size: 'normal' | 'small' }>((theme: Theme) => createStyles({
  riskValueText: ({ size }) => ({
    font: size === 'small' ? fontText('normal', theme.fontSize.s, 20) : fontText('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    position: 'relative',
    top: 1,
    textAlign: 'unset',
  }),
  labelValueWrapper: {
    font: fontText('normal', theme.fontSize.s, 20),
    color: theme.color.greys[60],
  },
  labelValue: {
    fontWeight: 600,
  },
}), { name: 'LabelWithTextRiskValue' });
